export default defineNuxtPlugin({
  name: 'pageTitle',
  parallel: true,
  enforce: 'post', // pre|default|post
  setup() {
    const router = useRouter();
    const pageTitle = useState<string>('pageTitle');

    router.beforeEach((_to, _from) => {
      pageTitle.value = '';
    });

    watch(pageTitle, (title) => {
      useHead({
        title: title || 'Финансовый сервис',
      });
    });

    return {
      provide: {
        pageTitle,
      },
    };
  },
});

interface PluginsInjections {
  $pageTitle: Ref<string>;
}

declare module '#app' {
  interface NuxtApp extends PluginsInjections {}
}
